import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "../static/lang/en";
import cns from "../static/lang/cns";
import cnt from "../static/lang/cnt";

import util from "./util";
Vue.use(VueI18n);

let lang = util.getCookie("_lang") || "en";

const i18n = new VueI18n({
  locale: lang,
  messages: {
    en: en,
    cns: cns,
    cnt: cnt
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js